var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSkyBlob1 = function SvgSkyBlob1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 737,
    height: 260,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 259.799V.009c185.951 0 205.226 77.998 316.343 123.596 111.117 45.598 346.39-11.4 420.657 136.194H0Z",
    fill: "#D5EAFF"
  })));
};
export default SvgSkyBlob1;